import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";
export async function protectedWhatsAppFetch(input, options = {}) {
  if (options.signal?.aborted)
    throw new DOMException("Cancelado", "AbortError");
  const url = new URL(input),
    payload = options.body
      ? JSON.parse(options.body)
      : { clinicId: url.searchParams.get("clinicId") };
  const response = await httpsCallable(functions, "relayClinicWhatsApp", {
    timeout: 65000,
  })({ endpoint: url.pathname, payload });
  const { status, body } = response.data;
  return { ok: status >= 200 && status < 300, status, json: async () => body };
}
